import React, { memo } from "react"

import styles from './styles.module.scss';

/**
 * Default wrapper/container for funnel pages. Returns a div.
 */
function WrapperDefault({children, ...rest}){
  return <div className={styles.wrapper} {...rest}>{children}</div>
}

export default memo(WrapperDefault);
